import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'

import { useGetPlan } from '@/app/module/plans/hooks/use-get-plan'
import { getPlanCountries } from '@/app/module/plans/utils'
import { numberWithCommas } from '@/app/service/util/format'

type Props = {}

const PlanDetails: React.FC<Props> = () => {
  const { data: plan } = useGetPlan()

  const name = plan?.label || ''
  const contactsCount = plan?.storedContactsNow || 0
  const contactsLimit = plan?.storedContactsMax || 0
  const usersCount = plan?.usersNow || 0
  const usersLimit = plan?.usersIncluded || 0
  const countries = plan?.countriesIncluded || ''

  const contactsCountFormatted = numberWithCommas(contactsCount)
  const contactsLimitFormatted = numberWithCommas(contactsLimit)
  const usersCountFormatted = numberWithCommas(usersCount)
  const usersLimitFormatted = numberWithCommas(usersLimit)
  const countriesValue = getPlanCountries(countries).value

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography color="textSecondary" variant="subtitle1">
        Plan: <strong>{name}</strong>
      </Typography>
      <Typography variant="body1">
        Contacts: {contactsCountFormatted} / {contactsLimitFormatted}
      </Typography>
      <Typography variant="body1">
        Users: {usersCountFormatted} / {usersLimitFormatted}
      </Typography>
      <Typography variant="body1">Countries: {countriesValue}</Typography>
    </Box>
  )
}

export default PlanDetails
